export const configureBlazeTheme = (sdk, contentType = 'story', displayTitle = false) => {
    const themeObject = sdk.Theme('row-circle', contentType);
    const isDesktop =
        typeof window !== 'undefined' &&
        window.matchMedia &&
        window.matchMedia('(min-width: 1024px)').matches;
    const colorUnread = getComputedStyle(document.documentElement)
        .getPropertyValue('--color-wsc-border-unread')
        .trim();


    const { layoutStyle } = themeObject;
    layoutStyle.statusUnreadStyle.thumbnailBorderColor = colorUnread;
    layoutStyle.statusLiveStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    layoutStyle.statusLiveUnreadStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    layoutStyle.statusReadStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    layoutStyle.statusUnreadStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    layoutStyle.badgeIndicatorStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';
    layoutStyle.labelStyle.font = '\'Founders Grotesk\', Helvetica, Tahoma, sans-serif';

    layoutStyle.isScrollEnabled = true;
    layoutStyle.rows = 1;
    layoutStyle.columns = 0;
    layoutStyle.itemRatio = 1;
    layoutStyle.horizontalItemsSpacing = 16;
    layoutStyle.borderWidth = 2;
    layoutStyle.borderRadius = '100%';
    layoutStyle.borderPadding = 2;
    layoutStyle.lines = 2;
    layoutStyle.statusIndicatorPosition = 'outsideBottom';
    layoutStyle.wordBreak = 'break-word';
    layoutStyle.statusUnreadStyle.isVisible = true;
    layoutStyle.statusUnreadStyle.backgroundColor = '#FFBA00';
    layoutStyle.statusUnreadStyle.textColor = '#06051e';

    if (layoutStyle.badgeIndicatorStyle) {
        layoutStyle.badgeIndicatorStyle.isVisible = false;
    }

    if (layoutStyle.labelStyle) {
        layoutStyle.labelStyle.isVisible = displayTitle;
        if (displayTitle) {
            layoutStyle.labelStyle.gap = isDesktop ? 6 : 4;
            layoutStyle.labelStyle.height = 16;
        } else {
            layoutStyle.labelStyle.gap = 0;
            layoutStyle.labelStyle.height = 0;
        }
        layoutStyle.labelStyle.color = '#FFFFFF';
        layoutStyle.labelStyle.padding = '0px';
        layoutStyle.labelStyle.position = 'outsideUnder';
        layoutStyle.labelStyle.fontSize = '14px';
        layoutStyle.labelStyle.fontWeight = 'normal';
        layoutStyle.labelStyle.backgroundColor = 'transparent';
    }

    return themeObject;
};

export const getBlazeDataSource = (sdk, labelsString) => {
    const labelArray = labelsString ? labelsString.split(',').map((l) => l.trim()).filter(Boolean) : [];

    if (labelArray.length === 0) {
        return sdk.DataSourceBuilder().all();
    }

    let labelsSource;

    if (labelArray.length > 1) {
        labelsSource = sdk.LabelBuilder().mustInclude(...labelArray);
    } else {
        labelsSource = sdk.LabelBuilder().singleLabel(labelArray[0]);
    }

    return sdk.DataSourceBuilder().labels({
        labels: labelsSource,
        maxItems: 20,
    });
};
